import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./BackButton.style.css";

function BackButton({ label = "Terug", className = "" }) {
    const navigate = useNavigate();

    const handleBack = () => {
        // Check if there's history to go back to
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            // Fallback to dashboard if no history
            navigate("/dashboard");
        }
    };

    return (
        <button
            type="button"
            className={`back-button btn btn-secondary ${className}`}
            onClick={handleBack}
            aria-label={label}
        >
            <span className="back-button-arrow" aria-hidden="true">←</span>
            <span className="back-button-text">{label}</span>
        </button>
    );
}

BackButton.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
};

export default BackButton;
